import React from "react";

import { KeyboardShortcutsDialog } from "#app/components/keyboard-shortcuts/keyboard-shortcuts-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

type KeyboardShortcutsDialogActions = {
  openDialog: () => void;
  closeDialog: () => void;
};

// Opened from the account menu, from the `?` hotkey registered in the
// workspace layout, and from inside portalled overlays.
const keyboardShortcutsDialog = createDialogEmitter("keyboard_shortcuts");

/** Open the keyboard-shortcuts reference. Module-level so a keydown handler
 *  can call it without a hook. */
export function openKeyboardShortcutsDialog(): void {
  keyboardShortcutsDialog.open();
}

/** Stable open/close callbacks. Works inside portalled overlays. */
export function useKeyboardShortcutsDialogActions(): KeyboardShortcutsDialogActions {
  return React.useMemo<KeyboardShortcutsDialogActions>(
    () => ({
      openDialog: keyboardShortcutsDialog.open,
      closeDialog: keyboardShortcutsDialog.close,
    }),
    [],
  );
}

/** Mounts the dialog once, in the workspace layout beside the other
 *  emitter-driven overlays. */
export function KeyboardShortcutsDialogMount() {
  const { open } = keyboardShortcutsDialog.useDialogState();
  return <KeyboardShortcutsDialog open={open} onClose={keyboardShortcutsDialog.close} />;
}
